import { ref } from 'vue-demi';

// 当前渠道index
export const activeChannel = ref(0);

// 当前渠道图片index
export const activeImage = ref(0);

// 当前渠道图片文案index
export const activeImageDesc = ref(0);

/**
 * 切换渠道
 */
export function changeChannel(index) {
    activeChannel.value = index;
    activeImage.value = 0;
    activeImageDesc.value = 0;
}

/**
 * 切换渠道图片
 */
export function changeImage(index) {
    activeImage.value = index;
    activeImageDesc.value = 0;
}

/**
 * 切换渠道图片文案
 */
export function changeImageDesc(index) {
    activeImageDesc.value = index;
}
